module.exports = __webpack_public_path__ + "media/public/img/landing_page/hiw2-rp-1590895dd5f28ba9eac2cb719c5e75f0.jpg";